import React, {useEffect, useState} from "react";
import {FaCheck} from "react-icons/fa";
import {MdError} from "react-icons/md";
import {IoIosWarning, IoMdNotifications} from "react-icons/io";

const Message: React.FC<any> = (props: any) => {
    const [message] = useState({
        value: props.value || props.children || '',
        type: props.type || 'info',
        timeout: props.timeout || 0
    });

    const onInit = async () => {
        if (!message.value) return;

        message.timeout > 0 && setTimeout(() => props.callback(null), message.timeout)
    }

    useEffect(() => { onInit() });

    return (
        <div className={`message-container type-${message.type} mb-3`}>
            <div className={`message-container__message d-flex align-items-center`}>
                {message.type && <>
                    {message.type === 'ok' && <FaCheck/>}
                    {message.type === 'info' && <IoMdNotifications/>}
                    {message.type === 'error' && <MdError/>}
                    {message.type === 'warning' && <IoIosWarning/>}
                </>}
                &nbsp;{message.value}
            </div>
        </div>
    )
}

export default Message
